import React, { useRef } from "react";
import ViewDocs from "./viewDocs";
import docTypes from "./docTypes";

const SelectZipFile = (props) => {

    const handleChange = (e) => {
        const zip = e.target.files[0];
        props.updateValue(zip);
    }

    return (
        <>
            <div className="input-field" style={{ height: "auto" }}>
                <div className="top-input">
                    { props.top }                                         
                    {
                        !props.upload && (
                            <div>
                                <ViewDocs path={'/docs/' + (props.dockerDocs ? docTypes.DOCKER : docTypes.PROGRAMMING)}/>
                            </div>
                        )
                    }
                    {
                        props.star

                        ?

                        <span className="required-star">
                            *
                        </span>

                        :

                        <>
                        </>
                    }
                </div>
                <div className="pdf-upload-container" style={{ height: "30px" }}>
                    <input ref={props.zipFileRef} type="file" className="pdf-choose" onChange={handleChange} required={ props.required } accept={props.accept}/>
                </div>
            </div>
        </>
    );
}

export default SelectZipFile;